module.exports = __webpack_public_path__ + "img/pohled_z_balkonu_4.ed3a51b2.jpg";